import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M18.5 5H14V3.5c0-.828-.672-1.5-1.5-1.5h-5C6.672 2 6 2.672 6 3.5V5H1.5C.672 5 0 5.672 0 6.5v10c0 .828.672 1.5 1.5 1.5h17c.828 0 1.5-.672 1.5-1.5v-10c0-.828-.672-1.5-1.5-1.5zM7 3.5c0-.276.224-.5.5-.5h5c.276 0 .5.224.5.5V5H7V3.5zM6 11v1H5v-1h1zm1 0v-.5c0-.276-.224-.5-.5-.5h-2c-.276 0-.5.224-.5.5v.5H1V6.5c0-.276.224-.5.5-.5h17c.276 0 .5.224.5.5V11h-3v-.5c0-.276-.224-.5-.5-.5h-2c-.276 0-.5.224-.5.5v.5H7zm8 0v1h-1v-1h1zm-2 1v.5c0 .276.224.5.5.5h2c.276 0 .5-.224.5-.5V12h3v4.5c0 .276-.224.5-.5.5h-17c-.276 0-.5-.224-.5-.5V12h3v.5c0 .276.224.5.5.5h2c.276 0 .5-.224.5-.5V12h6z',
  ],
  height: 20,
  width: 20,
});
